export enum PeriodicidadePagamentoEnum {
  MENSAL = 1,
  QUINZENAL = 14,
  DECENDIAL = 10,
  SEMANAL = 7
}